export const getUnixTime = (): number => (Date.now() / 1000) | 0;
